import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { getRevenueCentersList } from 'store/RevenueCenters/selector'
import { fetchRevenueCenters } from 'store/RevenueCenters/actions'
import { signOut } from 'store/Auth/actions'

import Layout from 'containers/Layout'
import RevenueCenters from 'containers/RevenueCenters'

const ReveneCenterList = ({ revenueCenters, fetchRevenueCenters, signOut }) => {
  useEffect(() => {
    fetchRevenueCenters()
  }, [])

  return (
    <Layout>
      <RevenueCenters revenueCenters={revenueCenters} signOut={signOut} />
    </Layout>
  )
}

ReveneCenterList.propTypes = {
  fetchRevenueCenters: PropTypes.func,
  revenueCenters: PropTypes.array,
  signOut: PropTypes.func,
}

const mapStateToProps = state => ({
  revenueCenters: getRevenueCentersList(state),
})

const mapDispatchToProps = {
  fetchRevenueCenters,
  signOut,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReveneCenterList)
